import Vue from 'vue';

export default {
  state: {},
  mutations: {},
  actions: {
    uploadFile(store, file) {
      const Fdata = new FormData();
      Fdata.append('files', file);
      const headers = { 'content-type': 'multipart/form-data' };
      return Vue.prototype.$axios.post('upload', Fdata, { headers }).then((resp) => resp.data[0]);
    },
    sendRequest(store, data) {
      const path = 'requests';
      return Vue.prototype.$axios.post(path, data).then((resp) => resp);
    },
  },
};
